import * as actionTypes from '../actions/actionTypes';
import { updateState } from '../../lib/StateHelper';

const initialState = {
    crumbs: []
};

const breadcrumbReducer = (state = initialState, action) => {
    let crumbs = null;

    switch (action.type) {
        case actionTypes.BREADCRUMB_ADD_ROUTE: {
            if (state.crumbs.length === 0) {
                state.crumbs.push({ key: 'dashboard', text: 'Dashboard', path: '/dashboard' });
            }

            const matched = state.crumbs.find(b => {
                return action.crumb.key === b.key || action.crumb.text === b.text;
            });

            if (matched) { return state; }

            crumbs = state.crumbs.concat(action.crumb);

            return updateState(state, { crumbs: crumbs });
        }
        case actionTypes.BREADCRUMB_REMOVE_ROUTE: {
            if (action.lastRouteIndex) {
                const crumbsToRemove = state.crumbs.slice(action.lastRouteIndex);
                crumbs = state.crumbs.filter(c => !crumbsToRemove.includes(c));
                return updateState(state, { crumbs: crumbs });
            } else {
                if (state.crumbs.length > 1) {
                    crumbs = state.crumbs.slice(0, state.crumbs.length - 1);
                    return updateState(state, { crumbs: crumbs });
                }
            }
            return state;
        }
        case actionTypes.BREADCRUMB_REMOVE_ALL_ROUTES: {
            return updateState(state, { crumbs: [] });
        }
        default: {
            return state;
        }
    }
};

export default breadcrumbReducer;
